module.exports = __webpack_public_path__ + "static/media/action.c6c30268.svg";